module.exports = __webpack_public_path__ + "img/Gstar.3d1335d8.png";